import React from "react";
import './PrivacyPolicy.css';
import RectangularLogo from './rectangular-logo.png';

export default function PrivacyPolicy() {
  return (
    <div className="privacy-policy-container">
      <main className="content">
        <img src={RectangularLogo} alt="SizzleWrap Logo" className="main-logo" />
        <h1 className="title">Privacy Policy</h1>
        <p className="date"><strong>Effective Date:</strong> April 24, 2025</p>

        <section className="section">
          <h2>1. Introduction</h2>
          <p>Welcome to SizzleWrap (“we,” “us,” or “our”). SizzleWrap connects to your Instagram account to generate and email you a personalized slideshow. We respect your privacy and protect your information in accordance with Meta’s Instagram Platform Policies.</p>
        </section>

        <section className="section">
          <h2>2. Information We Collect</h2>
          <h3>a. Information You Provide</h3>
          <br></br>
          <p>• <strong>Email Address:</strong> Required to deliver your slideshow.</p>
          <p>• <strong>Instagram OAuth Token:</strong> We store only the access token; your password is never stored.</p>

          <h3>b. Data Retrieved from Instagram</h3>
          <br></br>
          <p>• <strong>Profile Data:</strong> Username, profile picture URL, public biography.</p>
          <p>• <strong>Media Data:</strong> Public posts, captions, comments, timestamps.</p>

          <h3>c. Usage Data & Cookies</h3>
          <p>We collect IP address, browser type, device identifiers, and use cookies to maintain your session.</p>
        </section>

        <section className="section">
          <h2>3. How We Use Your Information</h2>
          <p>• Authenticate via OAuth and fetch your data.</p>
          <p>• Generate and email your personalized slideshow.</p>
          <p>• Monitor and improve our service (analytics and error diagnostics).</p>
        </section>

        <section className="section">
          <h2>4. Data Sharing</h2>
          <p>• <strong>Service Providers:</strong> Email delivery, analytics, and hosting providers.</p>
          <p>• <strong>Legal Requirements:</strong> Authorities when required by law.</p>
          <p>We do not sell or rent your personal data.</p>
        </section>

        <section className="section">
          <h2>5. Data Retention</h2>
          <p>• <strong>Instagram Data:</strong> Only data visible in the slideshow is stored by us. </p>
          <p>• <strong>Email & Account Data:</strong> Kept until you request deletion or close your account.</p>
        </section>

        <section className="section">
          <h2>6. Data Security</h2>
          <p>We use TLS encryption in transit and encrypted storage at rest to protect your information.</p>
        </section>

        <section className="section">
          <h2>7. Your Rights</h2>
          <p>You may access, correct, or delete your data; withdraw consent; or lodge a complaint with a data protection authority by contacting <a href="mailto:help@sizzlewrap.com">help@sizzlewrap.com</a>.</p>
        </section>

        <section className="section">
          <h2>8. Children’s Privacy</h2>
          <p>This service is not intended for children under 13. If you believe we have collected data from a child under 13, contact us to delete it.</p>
        </section>

        <section className="section">
          <h2>9. Changes to this Policy</h2>
          <p>We may update this policy. We will post the new effective date here. Please review periodically.</p>
        </section>
      </main>

      <footer className="footer">
        &copy; 2025 SizzleWrap. All rights reserved.
      </footer>
    </div>
  );
}
